export default __webpack_public_path__ + "static/media/m-sub-banner-num-2-hover.19872583.svg";